/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HealthGoalDto } from './HealthGoalDto';
import {
    HealthGoalDtoFromJSON,
    HealthGoalDtoFromJSONTyped,
    HealthGoalDtoToJSON,
    HealthGoalDtoToJSONTyped,
} from './HealthGoalDto';

/**
 * 
 * @export
 * @interface GoalsOfTreatmentUpsertRequestDto
 */
export interface GoalsOfTreatmentUpsertRequestDto {
    /**
     * The top 3 things the user would like to change about their health
     * @type {Array<HealthGoalDto>}
     * @memberof GoalsOfTreatmentUpsertRequestDto
     */
    healthGoals: Array<HealthGoalDto>;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof GoalsOfTreatmentUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the GoalsOfTreatmentUpsertRequestDto interface.
 */
export function instanceOfGoalsOfTreatmentUpsertRequestDto(value: object): value is GoalsOfTreatmentUpsertRequestDto {
    if (!('healthGoals' in value) || value['healthGoals'] === undefined) return false;
    return true;
}

export function GoalsOfTreatmentUpsertRequestDtoFromJSON(json: any): GoalsOfTreatmentUpsertRequestDto {
    return GoalsOfTreatmentUpsertRequestDtoFromJSONTyped(json, false);
}

export function GoalsOfTreatmentUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalsOfTreatmentUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'healthGoals': ((json['healthGoals'] as Array<any>).map(HealthGoalDtoFromJSON)),
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function GoalsOfTreatmentUpsertRequestDtoToJSON(json: any): GoalsOfTreatmentUpsertRequestDto {
    return GoalsOfTreatmentUpsertRequestDtoToJSONTyped(json, false);
}

export function GoalsOfTreatmentUpsertRequestDtoToJSONTyped(value?: GoalsOfTreatmentUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthGoals': ((value['healthGoals'] as Array<any>).map(HealthGoalDtoToJSON)),
        'isOnboarding': value['isOnboarding'],
    };
}

